import { OrgControllerService } from '@/__generated__/FrontApi';
import AccordionComponent, { AccordionItem } from '@/components/Accordion';
import Button from '@/components/Button';
import Container from '@/components/Container';
import Image from '@/components/Image';
import LinkSafe from '@/components/LinkSafe';
import Section from '@/components/Section';
import SectionHeader from '@/components/SectionHeader';
import { Tit } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

const namecardData = [
  {
    id: `0`,
    name: `정갑영`,
    tit: `회장`,
    dec: `연세대학교 명예특임교수`,
  },
  {
    id: `1`,
    name: `김은선`,
    tit: `부회장`,
    dec: `보령홀딩스 회장`,
  },
  {
    id: `2`,
    name: `이기철`,
    tit: `사무총장`,
    dec: `유니세프한국위원회 사무총장`,
  },
  {
    id: `3`,
    name: `여정성`,
    tit: `이사`,
    dec: `서울대 교육부총장`,
  },
  {
    id: `4`,
    name: `이원태`,
    tit: `이사`,
    dec: `금호아시아나 고문`,
  },
  {
    id: `5`,
    name: `김영지`,
    tit: `이사`,
    dec: `한국청소년정책연구원 선임연구위원`,
  },
  {
    id: `6`,
    name: `방순자`,
    tit: `이사`,
    dec: `한국열병합발전협회 협회장`,
  },
  {
    id: `7`,
    name: `서황욱`,
    tit: `이사`,
    dec: `구글 유튜브 한국·대만·홍콩·중국 파트너십 총괄 디렉터`,
  },
  {
    id: `8`,
    name: `홍석표`,
    tit: `이사`,
    dec: `법무법인 광장 변호사`,
  },
  {
    id: `9`,
    name: `이희범`,
    tit: `이사`,
    dec: `경북문화재단 대표이사`,
  },
  {
    id: `10`,
    name: `황덕남`,
    tit: `이사`,
    dec: `하나은행 사외이사·서울중앙지방 법원 및 서울고등법원 조정위원`,
  },
  {
    id: `11`,
    name: `전혜진`,
    tit: `이사`,
    dec: `한양사이버대학교 호텔외식경영학과 교수`,
  },
  {
    id: `12`,
    name: `김영철`,
    tit: `이사`,
    dec: `법무법인 케이씨엘 대표변호사`,
  },
  {
    id: `13`,
    name: `곽정환`,
    tit: `이사`,
    dec: `Cowell Group 회장`,
  },
  {
    id: `14`,
    name: `박형지`,
    tit: `이사`,
    dec: `연세대학교 영어영문학과 교수`,
  },
  {
    id: `15`,
    name: `남덕우`,
    tit: `감사`,
    dec: `한양대학교 경제금융대학 교수`,
  },
  {
    id: `16`,
    name: `김종연`,
    tit: `감사`,
    dec: `정진세림회계법인 전무이사`,
  },
];
const minutesData = [
  {
    id: `0`,
    tit: `2020년 유니세프한국위원회 제1차 임시이사회 회의록 (2020.04.17)`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ib29r&dispFileNm=KCU_board_meeting_200417.pdf&svrFileNm=KCU_board_meeting_200417.pdf`,
  },
  {
    id: `1`,
    tit: `2019년 유니세프한국위원회 제2차 임시이사회 회의록 (2019.09.18)`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ib29r&dispFileNm=KCU_board_meeting_190918.pdf&svrFileNm=KCU_board_meeting_190918.pdf`,
  },
  {
    id: `2`,
    tit: `2019년 유니세프한국위원회 제1차 임시이사회 회의록 (2019.06.12)`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ib29r&dispFileNm=KCU_board_meeting_190612.pdf&svrFileNm=KCU_board_meeting_190612.pdf`,
  },
  {
    id: `3`,
    tit: `2018년 유니세프한국위원회 제2차 정기이사회 회의록 (2018.10.30)`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ib29r&dispFileNm=KCU_board_meeting_181030.pdf&svrFileNm=KCU_board_meeting_181030.pdf`,
  },
  {
    id: `4`,
    tit: `2018년 유니세프한국위원회 임시총회 회의록 (2018.05.09)`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ib29r&dispFileNm=KCU_general_meeting_180509.pdf&svrFileNm=KCU_general_meeting_180509.pdf`,
  },
  {
    id: `5`,
    tit: `2018년 유니세프한국위원회 임시총회 회의록 (2018.03.28)`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ib29r&dispFileNm=KCU_general_meeting_180328.pdf&svrFileNm=KCU_general_meeting_180328.pdf`,
  },
  {
    id: `6`,
    tit: `2017년 유니세프한국위원회 임시총회 회의록 (2017.04.25)`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ib29r&dispFileNm=KCU_general_meeting_170425.pdf&svrFileNm=KCU_general_meeting_170425.pdf`,
  },
  {
    id: `7`,
    tit: `2016년 유니세프한국위원회 제2차 임시이사회 회의록 (2016.12.19)`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ib29r&dispFileNm=KCU_general_meeting_161219.pdf&svrFileNm=KCU_general_meeting_161219.pdf`,
  },
  {
    id: `8`,
    tit: `2016년 유니세프한국위원회 제1차 임시이사회 회의록 (2016.09.26)`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ib29r&dispFileNm=KCU_general_meeting_160926.pdf&svrFileNm=KCU_general_meeting_160926.pdf`,
  },
];

const NameCard = styled.ul`
  align-items: stretch;
  & > li {
    width: 25%;
    margin-bottom: 16px;

    .card {
      height: 153px;
      padding: 24px 24px 44px;
      background-color: #f8f9fa;
      dt {
        .title {
          display: inline-block;
          font-size: 16px;
          margin-left: 5px;
          font-weight: 700;
        }
      }
      dd {
        border-top: 1px solid #2d2926;
        margin-top: 16px;
        padding-top: 8px;
        word-wrap: break-word;
      }
    }
  }
  ${breakpoint(`tablet`)} {
    margin: 0 -12px;
    & > li {
      width: 50%;
      padding: 0 12px;

      .card {
        padding: 20px 12px;

        dd {
          margin-top: 12px;
          padding-top: 12px;
        }
      }
    }
  }
`;
const MinutesList = styled.ul`
  border-top: 1px solid #e5e6e8;
  max-height: 462px;
  overflow-y: auto;
  & > li {
    width: 100%;
    border-bottom: 1px solid #e5e6e8;

    .link-down {
      display: block;
      width: 100%;
      padding: 26px 24px;

      &::after {
        right: 26px;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
  }
  ${breakpoint(`tablet`)} {
    max-height: 285px;
    & > li {
      .link-down {
        padding: 20px 0 12px;
        padding-right: 30px;

        &::after {
          right: 0;
          top: 32px;
          transform: translate(0, -50%);
        }
      }
    }
  }
`;

const BtnFlex = styled.ul`
  & > li {
    width: 50%;
  }
  ${breakpoint(`tablet`)} {
    & > li {
      width: 100%;
      margin-bottom: 24px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

const NavigationButton = styled.div`
  padding: 24px;
  cursor: pointer;
  font-weight: bold;
  font-size: 20px;
  position: relative;

  dl {
    display: flex;
    align-items: center;

    dt {
      padding-right: 40px;
      font-size: 16px;
    }
  }

  ${breakpoint(`tablet`)} {
    padding: 24px 24px 24px 0;
  }
`;

const AccordionContainer = styled(AccordionComponent)`
  margin-top: 64px;
`;

const Contact = styled.table`
  margin-bottom: 64px;
  border-bottom: 1px solid #2d2926;
  th,
  td {
    padding: 12px 7px;
    height: 60px;
    border-bottom: none;
  }

  tbody {
    th,
    td {
      text-align: left;
      border-top: 1px solid #ddd !important;
      border-bottom: none;
    }
    tr:first-child {
      th,
      td {
        border-top: none;
      }
    }
    th {
      font-weight: 700;
      color: #3162af;
    }
  }

  ${breakpoint(`tablet`)} {
    th,
    td {
      padding: 10px 8px;
      height: 48px;
    }
  }
`;

const TblWarp = styled.div`
  overflow-x: auto;
  table {
    min-width: 470px;
  }
`;

const BludText = styled.span`
  color: #1cabe2;
`;

const SectionTop = styled(Section)`
  ${breakpoint(`tablet`)} {
    padding-top: 37px !important;
    padding-bottom: 0 !important;
  }
`;
const SectionChart = styled(Section)`
  ${breakpoint(`tablet`)} {
    padding-top: 72px !important;
  }
`;
const Page = styled.div``;

const OrganizationTab: React.FC = () => {
  const [contact, setContact] = useState();

  const loadPage = useCallback(async () => {
    const {
      data,
      resultCode,
    } = await OrgControllerService.getContactListUsingGet1({});

    if (resultCode !== `fail`) {
      setContact(data);
    }
  }, []);

  /* 조직도 차트 이미지 조회 추가 20211124 */
  const [orgChart, setOrgChart] = useState();
  const loadOrgChart = useCallback(async () => {
    const {
      data,
      resultCode,
    } = await OrgControllerService.getOrganizationUsingGet({});

    if (resultCode !== `fail`) {
      setOrgChart(data);
    }
  }, []);

  /* 이사회 목록 조회 추가 20211124 */
  const [council, setCouncil] = useState();
  const loadCouncil = useCallback(async () => {
    const { data, resultCode } = await OrgControllerService.getCouncilUsingGet(
      {},
    );

    if (resultCode !== `fail`) {
      setCouncil(data);
    }
  }, []);

  /* 총회/이사회 회의록 목록 조회 추가 20211124 */
  const [meeting, setMeeting] = useState();
  const loadMeeting = useCallback(async () => {
    const {
      data,
      resultCode,
    } = await OrgControllerService.getMeetinNoteUsingGet({});

    if (resultCode !== `fail`) {
      setMeeting(data);
    }
  }, []);

  useEffect(() => {
    loadPage();
    loadOrgChart();
    loadCouncil();
    loadMeeting();
  }, [loadPage, loadOrgChart, loadCouncil, loadMeeting]);

  return (
    <Page>
      <SectionTop className="by-sub-main-layout">
        <Container>
          <p className="dec">
            유니세프한국위원회는 도움을 주는 33개 유니세프 국가위원회 중 하나로,
            한국에서 유니세프를 대표해 유니세프의 이념을 실현합니다. 전 세계
            어린이를 위해 기금을 모으고 어린이 권리를 옹호합니다.&nbsp;
            <span className="c-blue">
              <LinkSafe
                to="/what-we-do/for-every-child/where-we-work"
                className="link-blank"
              >
                (유니세프 활동 지역
              </LinkSafe>
              <BludText>)</BludText>
            </span>
          </p>
        </Container>
      </SectionTop>

      <SectionChart className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">조직도</Tit>
            </h2>
          </SectionHeader>
          {!!orgChart &&
            orgChart.map((row) => (
              <Image
                key={row.indexNumber}
                pcSrc={row.imgAttGrpNoPc}
                mobileSrc={row.imgAttGrpNoMob}
              />
            ))}
          {/* <Image pcSrc={OrganizationChart} mobileSrc={OrganizationChart} /> */}
        </Container>
      </SectionChart>

      <Section className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">이사회</Tit>
            </h2>
          </SectionHeader>

          <NameCard className="flex">
            {!!council &&
              council.map((row, index) => (
                <li key={index}>
                  <dl className="card">
                    <dt>
                      <Tit size="s4">{row.name}</Tit>
                      {row.position && (
                        <small className="title">{row.position}</small>
                      )}
                    </dt>
                    <dd>
                      <p className="dec">{row.info}</p>
                    </dd>
                  </dl>
                </li>
              ))}
            {/* {namecardData.map((row, index) => (
              <li key={index}>
                <dl className="card">
                  <dt>
                    <Tit size="s4">{row.name}</Tit>
                    {row.tit && <small className="title">{row.tit}</small>}
                  </dt>
                  <dd>
                    <p className="dec">{row.dec}</p>
                  </dd>
                </dl>
              </li>
            ))} */}
          </NameCard>
          <AccordionContainer initialKey="1">
            <AccordionItem
              key="0"
              toggleKey="0"
              renderToggle={(onClick) => (
                <NavigationButton
                  onClick={onClick}
                  className="accordion-opener"
                >
                  <Tit size="s4">총회/이사회 회의록</Tit>
                </NavigationButton>
              )}
            >
              <MinutesList>
                {!!meeting &&
                  meeting.map((row, index) => (
                    <li key={index}>
                      {row.arrAttFile?.length &&
                        row.arrAttFile.map((file) => (
                          <LinkSafe to={file.downloadUrl} className="link-down">
                            {row.year} {row.title} (
                            {dayjs(row.dispDate).format(`YYYY.MM.DD`)})
                          </LinkSafe>
                        ))}
                    </li>
                  ))}
                {/* {minutesData.map((row, index) => (
                  <li key={index}>
                    <LinkSafe to={row.link} className="link-down">
                      {row.tit}
                    </LinkSafe>
                  </li>
                ))} */}
              </MinutesList>
            </AccordionItem>
          </AccordionContainer>
        </Container>
      </Section>

      <Section className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">정관</Tit>
            </h2>
          </SectionHeader>
          <BtnFlex className="flex">
            <li>
              <Button
                outline
                full
                ico="down"
                className="btn-report"
                onClick={() =>
                  window.open(
                    `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ib29r&dispFileNm=statute_kor.pdf&svrFileNm=statute_kor.pdf`,
                  )
                }
              >
                <span className="ico">국문</span>
              </Button>
            </li>
            <li>&nbsp;</li>
          </BtnFlex>
        </Container>
      </Section>

      <Section className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">연락처</Tit>
            </h2>
          </SectionHeader>
          <TblWarp>
            <Contact className="tbl1">
              <colgroup>
                <col />
                <col />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th>분야</th>
                  <th>E-mail</th>
                  <th>연락처</th>
                </tr>
              </thead>
              <tbody>
                {!!contact &&
                  contact.map((row, index) =>
                    !row.business ? (
                      <tr key={index}>
                        <th colSpan="3">{row.departmentName}</th>
                      </tr>
                    ) : (
                      <tr key={index}>
                        <td>{row.business}</td>
                        <td>{row.email}</td>
                        <td>{row.telNumber}</td>
                      </tr>
                    ),
                  )}
              </tbody>
            </Contact>
          </TblWarp>
        </Container>
      </Section>
    </Page>
  );
};
export default OrganizationTab;
